import { ProgressiveImageProps } from '../hooks/useProgressiveImage/useProgressiveImage';

export const COLLECTION_THUMBNAIL_CACHE_KEY = 'COLLECTION_THUMBNAILS';
const CACHE_TIME = 2629800000; /* 1 month */

type CachedImageProps = Pick<ProgressiveImageProps, 'src' | 'alt' | 'srcSet' | 'placeholderSrc' | 'width' | 'height'>;

const getCache = (): Record<string, { imageProps: CachedImageProps; timestamp: number }> => {
  try {
    return JSON.parse(sessionStorage.getItem(COLLECTION_THUMBNAIL_CACHE_KEY) ?? '{}');
  } catch (err: unknown) {
    return {};
  }
};

const setCache = (cache: Record<string, { imageProps: CachedImageProps; timestamp: number }>) => {
  sessionStorage.setItem(COLLECTION_THUMBNAIL_CACHE_KEY, JSON.stringify(cache));
};

const isCachedImageExpired = (timestamp: number) => {
  return timestamp + CACHE_TIME < Date.now();
};

export const getCachedCollectionImage = (handle?: string) => {
  const collectionImages = getCache();
  if (!handle || !collectionImages[handle]) return undefined;

  if (isCachedImageExpired(collectionImages[handle].timestamp)) {
    delete collectionImages[handle];
    setCache(collectionImages);
    return undefined;
  }

  return collectionImages[handle].imageProps;
};

export const setCachedCollectionImage = (handle: string, imageProps: CachedImageProps) => {
  const collectionImages = getCache();
  collectionImages[handle] = { timestamp: Date.now(), imageProps };
  setCache(collectionImages);
};
